module.exports = "<label class=\"y-radio-item\" data-bind=\"attr: {fieldid: fieldid},css:{'y-radio-item-checked': checked,'y-radio-item-disabled':disabled}\">\n  <span class=\"y-radio-item--inner-warpper\">\n    <span class=\"y-radio-item-inner\">\n      <input type=\"radio\" data-bind=\"attr:{disabled:disabled,name:radioname},checked: checked, event:{change:change }\">\n    </span>\n  </span>\n  <span class=\"y-radio-label\" data-bind=\"text:value.label\"></span>\n</label>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/radio/radioitem.html
// module id = 207
// module chunks = 0